/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Audience_AriaInputs */

const en_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audience`)
};

const es_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel del jugador`)
};

const de_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielgruppe`)
};

const zh_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标人群`)
};

const ar_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفئة المستهدفة`)
};

const fr_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau du joueur`)
};

const vi_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đối tượng`)
};

const sw_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiwango cha mchezaji`)
};

const th_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กลุ่มเป้าหมาย`)
};

const bs_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciljna grupa`)
};

const ja_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対象レベル`)
};

const ko_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대상`)
};

const pt_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível do jogador`)
};

const it_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livello del giocatore`)
};

const sv_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Målgrupp`)
};

const nl_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doelgroep`)
};

const da_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Målgruppe`)
};

const nb_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Målgruppe`)
};

const fi_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohderyhmä`)
};

const pl_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupa docelowa`)
};

const ru_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевая аудитория`)
};

const tr_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hedef kitle`)
};

const hi_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लक्षित समूह`)
};

const id_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkat pemain`)
};

const ms_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahap pemain`)
};

const cs_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cílová skupina`)
};

const el_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επίπεδο παίκτη`)
};

const he_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קהל יעד`)
};

const af_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teikengroep`)
};

const hu_method_audience_aria = /** @type {(inputs: Method_Audience_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Célcsoport`)
};

/**
* | output |
* | --- |
* | "Audience" |
*
* @param {Method_Audience_AriaInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_audience_aria = /** @type {((inputs?: Method_Audience_AriaInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Audience_AriaInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_audience_aria(inputs)
	if (locale === "de") return de_method_audience_aria(inputs)
	if (locale === "zh") return zh_method_audience_aria(inputs)
	if (locale === "ar") return ar_method_audience_aria(inputs)
	if (locale === "fr") return fr_method_audience_aria(inputs)
	if (locale === "vi") return vi_method_audience_aria(inputs)
	if (locale === "sw") return sw_method_audience_aria(inputs)
	if (locale === "th") return th_method_audience_aria(inputs)
	if (locale === "bs") return bs_method_audience_aria(inputs)
	if (locale === "ja") return ja_method_audience_aria(inputs)
	if (locale === "ko") return ko_method_audience_aria(inputs)
	if (locale === "pt") return pt_method_audience_aria(inputs)
	if (locale === "it") return it_method_audience_aria(inputs)
	if (locale === "sv") return sv_method_audience_aria(inputs)
	if (locale === "nl") return nl_method_audience_aria(inputs)
	if (locale === "da") return da_method_audience_aria(inputs)
	if (locale === "nb") return nb_method_audience_aria(inputs)
	if (locale === "fi") return fi_method_audience_aria(inputs)
	if (locale === "pl") return pl_method_audience_aria(inputs)
	if (locale === "ru") return ru_method_audience_aria(inputs)
	if (locale === "tr") return tr_method_audience_aria(inputs)
	if (locale === "hi") return hi_method_audience_aria(inputs)
	if (locale === "id") return id_method_audience_aria(inputs)
	if (locale === "ms") return ms_method_audience_aria(inputs)
	if (locale === "cs") return cs_method_audience_aria(inputs)
	if (locale === "el") return el_method_audience_aria(inputs)
	if (locale === "he") return he_method_audience_aria(inputs)
	if (locale === "af") return af_method_audience_aria(inputs)
	if (locale === "hu") return hu_method_audience_aria(inputs)
	return en_method_audience_aria(inputs)
});